import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { API } from "aws-amplify";
import { listProductCategorys } from "../../graphql/queries";
import "./Multiselect.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

function getStyles(name, personName, theme) {
	return {
		fontWeight: 600,
	};
}

export default function CatergorySelect({
	personName,
	setPersonName,
	setcategoryData,
	categoryData,
}) {
	const theme = useTheme();
	const { t } = useTranslation();
	const lang = useSelector((state) => state.language.lang);
	const [cat, setCat] = React.useState([]);
	const handleChange = (event) => {
		const {
			target: { value },
		} = event;
		setPersonName(typeof value === "string" ? value.split(",") : value);
	};

	React.useEffect(() => {
		if (personName.length) {
			const allData = cat.filter((item) =>
				personName.find((catItem) => item.categoryName === catItem),
			);
			setcategoryData(allData);
		}
	}, [personName]);

	const category = async () => {
		const categorylist = await API.graphql({
			query: listProductCategorys,
			authMode: "API_KEY",
		});
		setCat(categorylist.data.listProductCategorys.items);
	};

	React.useEffect(() => {
		category();
	}, []);

	return (
		<div className="multiselect">
			<FormControl sx={{ m: 1, width: 300, mt: 3 }}>
				<Select
					multiple
					displayEmpty
					value={personName}
					onChange={handleChange}
					input={<OutlinedInput />}
					renderValue={(selected) => {
						if (selected.length === 0) {
							return <p style={{ color: "#898989" }}>Choisir une catégorie</p>;
						}
						return selected.join(", ");
					}}
					MenuProps={MenuProps}
					inputProps={{ "aria-label": "Without label" }}
				>
					<MenuItem disabled value="">
						Choisir une catégorie
					</MenuItem>
					{cat.map((name) => (
						<MenuItem
							key={name.id}
							value={name.categoryName}
							style={getStyles(name.categoryName, personName, theme)}
						>
							{name.categoryName}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}
